export default __webpack_public_path__ + "media/samples/FUNDEMANTALS_03-96965702.jpg";